export default "__VITE_ASSET__CeLUeiLb__"